<template lang="pug">
  div
    PhoValidationProvider(name="category" :rules="rules")
      v-autocomplete(
        ref="autocompleteRef"
        v-model="lazyValue"
        multiple
        return-object
        attach
        dense
        outlined
        item-value="id"
        item-text="displayName"
        :items="lazyCategories"
        :label="$t($lang.content.CATEGORY)"
        :search-input.sync="search"
        @change="onValueChanged"
        :disabled="disabled"
      )
        template(v-slot:selection='{ item }')
          div(:class="item.class" class="v-select__selection v-select__selection--comma list-with-comma") {{ item.displayName }}
</template>
<script>

import { map, pick } from 'ramda';
import {
  computed, nextTick, onMounted, ref, watch,
} from 'vue';
import { useSelectedSorter } from '@/helpers/misc';
import { filterSelectedObjects } from '@/helpers/content';
import { useModelBinding } from '@/helpers/misc/binding';
import { useRouter } from '@/helpers/misc/useRouter';
import { getCategories } from '@/api/category/CategoryApi';
import { PhoValidationProvider } from '../misc/form';

export default {
  name: 'Category',
  components: {
    PhoValidationProvider,
  },
  props: {
    value: {
      type: Array,
    },
    rules: {
      type: String,
      default: '',
    },
    contentType: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { lazyValue, updateValue } = useModelBinding(emit, props, []);
    const allCategories = ref([]);
    const search = ref('');
    const previouslySelectedIds = ref([]);
    const autocompleteRef = ref(null);

    const getCategoryTextClass = item => {
      if (!item.isApproved || !item.contentTypes.includes(props.contentType) || item.options?.isContentCreationDisabled) {
        return 'red--text';
      }

      return '';
    };

    const isSelectableCategory = item => item.isApproved && item.contentTypes
      && item.contentTypes.includes(props.contentType)
      && !item.options?.isContentCreationDisabled;

    const lazyItems = computed(() => {
      const selectableCategories = allCategories.value.filter(isSelectableCategory);
      // bir kategorinin secilebilir alt kategorisi varsa kendisi tek basina secenek olarak listelenmez
      const parentIds = new Set(selectableCategories.flatMap(item => item.hierarchy ?? []));

      const categoriesToShow = allCategories.value.filter(item => (isSelectableCategory(item) && !parentIds.has(item.id))
        || previouslySelectedIds.value.some(selectedId => selectedId.id === item.id));

      categoriesToShow.forEach(item => {
        item.class = getCategoryTextClass(item);
      });

      return categoriesToShow;
    });

    const [lazyCategories] = useSelectedSorter(lazyItems, lazyValue, filterSelectedObjects, 'id');

    onMounted(async () => {
      allCategories.value = await getCategories({});
    });

    const updatePreviouslySelectedIds = () => {
      if (lazyValue.value) {
        previouslySelectedIds.value = [...previouslySelectedIds.value, ...lazyValue.value];
      }
    };

    watch(lazyValue, updatePreviouslySelectedIds);

    useRouter(async () => {
      previouslySelectedIds.value = [];
    });

    const onValueChanged = values => {
      updateValue(map(pick(['id', 'hierarchy']), values));
      search.value = '';

      if (props.closeOnSelect) {
        nextTick(() => {
          autocompleteRef.value?.blur();
        });
      }
    };

    return {
      search,
      lazyValue,
      lazyCategories,
      onValueChanged,
      autocompleteRef,
    };
  },
};
</script>
